import CartTable from "./CartTable";

import CartNav from "./CartNav";
import CartTotal from "./CartTotal";

// Component giỏ hàng
const Cart = (props) => {
  return (
    <section className="cart_section">
      <div className="row cart_section_flex">
        <div className=" col-12 col-md-8 col-lg-9 cart_table_wrap">
          <CartTable items={props.cartArr} />
          <CartNav totalPrice={props.totalPrice} />
        </div>

        <div className="col-12 col-md-4 col-lg-3">
          <CartTotal totalPrice={props.totalPrice} />
        </div>
      </div>
    </section>
  );
};

export default Cart;
